/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'wXY4HxzTmhfU8xhn9puyst.png': { uri: '/images/wXY4HxzTmhfU8xhn9puyst.png' },
'awQx5pYrTmrNCoUEGPw5Hh.png': { uri: '/images/awQx5pYrTmrNCoUEGPw5Hh.png' },
'juvAXpVsUsYVWoSrCRog4m.png': { uri: '/images/juvAXpVsUsYVWoSrCRog4m.png' },
'quAaZN2J7vzSrSBfuHTpeu.png': { uri: '/images/quAaZN2J7vzSrSBfuHTpeu.png' },
'wYdQHty5QHBkQxrtyF9MUU.png': { uri: '/images/wYdQHty5QHBkQxrtyF9MUU.png' },
'q9nwTkvc76R1eZmHHxZJ8A.png': { uri: '/images/q9nwTkvc76R1eZmHHxZJ8A.png' },
'apBoixpAWA7r87sp9x3Ccb.png': { uri: '/images/apBoixpAWA7r87sp9x3Ccb.png' },
'5wESX1YMjZ84uDq4u5YdSq.png': { uri: '/images/5wESX1YMjZ84uDq4u5YdSq.png' },
'haNsjZebizDfyRZ6uSuJvZ.png': { uri: '/images/haNsjZebizDfyRZ6uSuJvZ.png' },
'41LqjH8t5wGP8aY2mt5Bfx.png': { uri: '/images/41LqjH8t5wGP8aY2mt5Bfx.png' },
'fioCMuEsZD7mWGQMK6fi6W.png': { uri: '/images/fioCMuEsZD7mWGQMK6fi6W.png' },
'sDhEcED5PTAghd64d7gHUh.png': { uri: '/images/sDhEcED5PTAghd64d7gHUh.png' },
'mtEM1Yh7TjX53rTLdKQtga.png': { uri: '/images/mtEM1Yh7TjX53rTLdKQtga.png' },
'4fBiFYVzxiVrnWyqk9Q1Ej.png': { uri: '/images/4fBiFYVzxiVrnWyqk9Q1Ej.png' },
'bfqXLG5yGUu1e2V2kueSGG.png': { uri: '/images/bfqXLG5yGUu1e2V2kueSGG.png' },
'rty6sjq8U2gtSczvFmVwSn.png': { uri: '/images/rty6sjq8U2gtSczvFmVwSn.png' },
'pMX8VSTgBx4ywJR5oBti3T.png': { uri: '/images/pMX8VSTgBx4ywJR5oBti3T.png' },
'38uUf64Lwpor3Wd5C85mHB.png': { uri: '/images/38uUf64Lwpor3Wd5C85mHB.png' },
'7ASa8jAUq1yp8LwMJFvENX.png': { uri: '/images/7ASa8jAUq1yp8LwMJFvENX.png' },
'86wZHPDG2jHttofnRT1Ysh.png': { uri: '/images/86wZHPDG2jHttofnRT1Ysh.png' },
'jxW5Hb2AUmX9FauVCzVC55.png': { uri: '/images/jxW5Hb2AUmX9FauVCzVC55.png' },
'ppnSSdHLm2sFHPtyETPMDR.png': { uri: '/images/ppnSSdHLm2sFHPtyETPMDR.png' },
'vTTZ2RPSmxQEXw5nPy92d5.png': { uri: '/images/vTTZ2RPSmxQEXw5nPy92d5.png' },
'8KLc5abbm3BuVBusaJ6qey.png': { uri: '/images/8KLc5abbm3BuVBusaJ6qey.png' },
'3yH9APhuwFbCZnKP8H32SJ.png': { uri: '/images/3yH9APhuwFbCZnKP8H32SJ.png' },
'wCPxeZ3x3pfSAWAonpuC54.png': { uri: '/images/wCPxeZ3x3pfSAWAonpuC54.png' },
'dXXsq6y4oZxNoK1ePyPLsx.png': { uri: '/images/dXXsq6y4oZxNoK1ePyPLsx.png' },
'uyLYi6kuCN2mSg2Ydw7XPt.png': { uri: '/images/uyLYi6kuCN2mSg2Ydw7XPt.png' },
'dhPRXvcG8TuuDKhkyBrr4d.png': { uri: '/images/dhPRXvcG8TuuDKhkyBrr4d.png' },
'2ME5XDJftpYP4yaLK52VuD.png': { uri: '/images/2ME5XDJftpYP4yaLK52VuD.png' },
'ocQ7225PWa1SGRrdevGuMC.png': { uri: '/images/ocQ7225PWa1SGRrdevGuMC.png' },
'qjKzZZs1RmATAzUFCLE3bz.png': { uri: '/images/qjKzZZs1RmATAzUFCLE3bz.png' },
'6MfKoNXbbjpFCmD7BdCf1o.png': { uri: '/images/6MfKoNXbbjpFCmD7BdCf1o.png' },
'i4Mq7stBqshgQPF22fqvGS.png': { uri: '/images/i4Mq7stBqshgQPF22fqvGS.png' },
'oYJjnxfr7EkUqsqvDgLfk6.png': { uri: '/images/oYJjnxfr7EkUqsqvDgLfk6.png' },
'bPGrWejUpuiPsr8dds8cpb.png': { uri: '/images/bPGrWejUpuiPsr8dds8cpb.png' },
'7TcQB7Zi2v3Qd2X5Phy34u.png': { uri: '/images/7TcQB7Zi2v3Qd2X5Phy34u.png' },
'6WYqezqedGsscQThaWH6vZ.png': { uri: '/images/6WYqezqedGsscQThaWH6vZ.png' },
'jX2YGjG6S6vtFc5T1jNF2z.png': { uri: '/images/jX2YGjG6S6vtFc5T1jNF2z.png' },
'mu6hNr7247ZEGvwEJYYqhj.jpg': { uri: '/images/mu6hNr7247ZEGvwEJYYqhj.jpg' },
'ot3Bw7uiMJZK59TDssv4Gq.png': { uri: '/images/ot3Bw7uiMJZK59TDssv4Gq.png' },
'eicqGH7BT7i3QXWJdbPqoK.png': { uri: '/images/eicqGH7BT7i3QXWJdbPqoK.png' },
'rbL68osTaDzut1uNDtW9zV.jpg': { uri: '/images/rbL68osTaDzut1uNDtW9zV.jpg' },
'mqbQjS6DkKUSrK9LCwSMqt.png': { uri: '/images/mqbQjS6DkKUSrK9LCwSMqt.png' },
'tynBpzpkCKtp3Gy79bdAdi.png': { uri: '/images/tynBpzpkCKtp3Gy79bdAdi.png' },
'm5FGx3xX95pBSnZyQRpqNb.jpg': { uri: '/images/m5FGx3xX95pBSnZyQRpqNb.jpg' },
'7Q2jZZHC5zyAVhGo2LZCPL.png': { uri: '/images/7Q2jZZHC5zyAVhGo2LZCPL.png' },
'cyxWPDsEhvZbegiuZzKnJt.png': { uri: '/images/cyxWPDsEhvZbegiuZzKnJt.png' },
'ke9PjdnwajjyhzBaG6kdkZ.png': { uri: '/images/ke9PjdnwajjyhzBaG6kdkZ.png' },
'qQndTtN8gGVaW6bpgXTtob.jpg': { uri: '/images/qQndTtN8gGVaW6bpgXTtob.jpg' },
'kHn2dk3yGeCaeZjYwUncE9.jpg': { uri: '/images/kHn2dk3yGeCaeZjYwUncE9.jpg' },
'4j1So5JjqkLFnKXkDp7SnQ.png': { uri: '/images/4j1So5JjqkLFnKXkDp7SnQ.png' },
'heVDncfie8uWabFAJciAdA.png': { uri: '/images/heVDncfie8uWabFAJciAdA.png' },
'bK9uAsdyRCicBrfKdAUGyg.png': { uri: '/images/bK9uAsdyRCicBrfKdAUGyg.png' },
'8tXdH8uNuMFctnzriFHF2f.png': { uri: '/images/8tXdH8uNuMFctnzriFHF2f.png' },
'uJLkf1E3AfWa5Q8jhqN4R2.png': { uri: '/images/uJLkf1E3AfWa5Q8jhqN4R2.png' },
'bxvaUPuwSaXAV8uM3rX15M.png': { uri: '/images/bxvaUPuwSaXAV8uM3rX15M.png' },
'o3mHzhyHdYJRJq2SFcXdgx.png': { uri: '/images/o3mHzhyHdYJRJq2SFcXdgx.png' },
'1M22xAzB2a18tnHJAoua1X.png': { uri: '/images/1M22xAzB2a18tnHJAoua1X.png' },
'4LFS8xysLBxwu5gEXiZu8q.png': { uri: '/images/4LFS8xysLBxwu5gEXiZu8q.png' },
'oDLc3VCwHkuwG23uv73HUE.png': { uri: '/images/oDLc3VCwHkuwG23uv73HUE.png' },
'jmcCg3sGhy3e3i2cMvDtoq.png': { uri: '/images/jmcCg3sGhy3e3i2cMvDtoq.png' },
'ttbp2eAb6v8c6CkXJgC64f.png': { uri: '/images/ttbp2eAb6v8c6CkXJgC64f.png' },
'gKR1WgeeijpniENpZWYPAq.png': { uri: '/images/gKR1WgeeijpniENpZWYPAq.png' },
'rDnCde4pwxFdTHFGc5qhZD.png': { uri: '/images/rDnCde4pwxFdTHFGc5qhZD.png' },
'gLUsAn7w67EEMgFh2MBf5N.png': { uri: '/images/gLUsAn7w67EEMgFh2MBf5N.png' },
'p3SLkYMxgEScYmFf9TKLUr.png': { uri: '/images/p3SLkYMxgEScYmFf9TKLUr.png' },
'644u2Wo9PeJeBJ4pkCsrDa.png': { uri: '/images/644u2Wo9PeJeBJ4pkCsrDa.png' },
'nwJzsqgKzA5jPVxm1LzJW1.png': { uri: '/images/nwJzsqgKzA5jPVxm1LzJW1.png' },
'dwqMGp5h6pidNXNs21iSYn.png': { uri: '/images/dwqMGp5h6pidNXNs21iSYn.png' },
'1PG1D1uQCVCNkGH14wXHRr.png': { uri: '/images/1PG1D1uQCVCNkGH14wXHRr.png' },
'4YPUD9KBZSASuXx6HbeQW5.png': { uri: '/images/4YPUD9KBZSASuXx6HbeQW5.png' },
'fNVK27oX64yn2g8uYeC9TC.png': { uri: '/images/fNVK27oX64yn2g8uYeC9TC.png' },
'mQ3YSNG2KE9LEdWyPXSHLa.png': { uri: '/images/mQ3YSNG2KE9LEdWyPXSHLa.png' },
'kv3y4DaMZNCkno4xHeaMim.png': { uri: '/images/kv3y4DaMZNCkno4xHeaMim.png' },
'trXFFCZKFmcwTPBqSU5cUr.png': { uri: '/images/trXFFCZKFmcwTPBqSU5cUr.png' },
'wjcgRikjc5M2LgTKWZdZV6.png': { uri: '/images/wjcgRikjc5M2LgTKWZdZV6.png' },
'ieMGDoYC7bty6n9xXxXMnY.png': { uri: '/images/ieMGDoYC7bty6n9xXxXMnY.png' },
'ianNdVcev2Vx9noRJc3CuQ.png': { uri: '/images/ianNdVcev2Vx9noRJc3CuQ.png' },
'sJGQ6RYbgZzV97WM7X3zBS.png': { uri: '/images/sJGQ6RYbgZzV97WM7X3zBS.png' },
'bHhpHBYce7uraygCn6nahH.png': { uri: '/images/bHhpHBYce7uraygCn6nahH.png' },
'i5PweQfDXva3jSBAMGdHGC.png': { uri: '/images/i5PweQfDXva3jSBAMGdHGC.png' },
'p8914ZbdytsVXn8GTzdFfE.png': { uri: '/images/p8914ZbdytsVXn8GTzdFfE.png' },
'kibZofymzwyPFpaRAWHYUq.png': { uri: '/images/kibZofymzwyPFpaRAWHYUq.png' },
'5x9Hs48R5S2xcVnWxtBzju.png': { uri: '/images/5x9Hs48R5S2xcVnWxtBzju.png' },
'8sNYXQppYZAkpHAszvLk3B.png': { uri: '/images/8sNYXQppYZAkpHAszvLk3B.png' },
'r6ufcccEYEZBw6zRQkJ8qf.png': { uri: '/images/r6ufcccEYEZBw6zRQkJ8qf.png' },
'1WFjqUMkGt3mx1PzDPkHSS.png': { uri: '/images/1WFjqUMkGt3mx1PzDPkHSS.png' },
'qDFCLvSX8uxmVkzfrEhap1.png': { uri: '/images/qDFCLvSX8uxmVkzfrEhap1.png' },
'2YPiNEuZq6sYiB2R7pGQQs.png': { uri: '/images/2YPiNEuZq6sYiB2R7pGQQs.png' },
'4LcYswAfXYfzkE6sDUYDRR.jpg': { uri: '/images/4LcYswAfXYfzkE6sDUYDRR.jpg' },
'pN73PFZC4Me2jYU6s5udhR.png': { uri: '/images/pN73PFZC4Me2jYU6s5udhR.png' },
'1a17KDTCN5g8d7wPv4WXm3.png': { uri: '/images/1a17KDTCN5g8d7wPv4WXm3.png' },
'avMwPRtaiFGNGBX5kMromu.png': { uri: '/images/avMwPRtaiFGNGBX5kMromu.png' },
'9mSbke2TUGSZT1ASPgRius.jpg': { uri: '/images/9mSbke2TUGSZT1ASPgRius.jpg' },
'8rADyhB9oNrr4uFFt6v9XN.jpg': { uri: '/images/8rADyhB9oNrr4uFFt6v9XN.jpg' },
'wTk68FQrwZYtjYR5TeuhXH.jpg': { uri: '/images/wTk68FQrwZYtjYR5TeuhXH.jpg' },
'cMtzaynkGKToM8vG6BmtdA.jpg': { uri: '/images/cMtzaynkGKToM8vG6BmtdA.jpg' },
'mdG14qKxqS8cZx58NdhG56.jpg': { uri: '/images/mdG14qKxqS8cZx58NdhG56.jpg' },
'nyxfaVVu5dLfXUkzsWg8Gw.jpg': { uri: '/images/nyxfaVVu5dLfXUkzsWg8Gw.jpg' },
'ni5KtSAbs7ZzcPktVEnL2r.png': { uri: '/images/ni5KtSAbs7ZzcPktVEnL2r.png' },
'cLPSSG2wwPWvnY9kXJgxC1.png': { uri: '/images/cLPSSG2wwPWvnY9kXJgxC1.png' },
'139dU9Bx6SEWjtjBZbwPPX.png': { uri: '/images/139dU9Bx6SEWjtjBZbwPPX.png' },
'bfU9YHgBBGeeTgucnRWHCw.png': { uri: '/images/bfU9YHgBBGeeTgucnRWHCw.png' },
'jahHqfAiwr8DV1jexfyVP6.png': { uri: '/images/jahHqfAiwr8DV1jexfyVP6.png' }
}

export default imageStaticSourcesByFileName
